var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#173261"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.2205 22.5V8.535H5.2725V14.311H6.8685V8.535H8.9205V22.5H6.8685V16.42H5.2725V22.5H3.2205ZM11.3883 22.5V10.644H9.45027V8.535H15.3783V10.644H13.4403V22.5H11.3883ZM15.9109 22.5V8.535H18.5139L19.6349 15.774L19.7299 16.515H19.7679L19.8629 15.774L20.9839 8.535H23.5869V22.5H21.6869V13.133H21.5729L21.4969 13.722L20.2809 22.5H19.2169L18.0009 13.722L17.9249 13.133H17.8109V22.5H15.9109ZM24.696 22.5V8.535H26.748V20.6H29.465V22.5H24.696Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.9474de80f9600c9c288b6fbacfd85e76.svg";
export { ForwardRef as ReactComponent };